// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qElY","textarea":"styles_textarea__2Dle0"};